import { schema } from 'normalizr'
import { stringify } from 'query-string'
import {
  CALL_API,
  createEntitiesSelector,
  createSelectorForEntityKey,
} from '@infotech/lib-api-middleware'
import { REACT_APP_REFERENSE_PASSPORT } from './constants'

export const EQUIPMENTS_SCHEMA_NAME = `equipments`

const equipmentsSchema = new schema.Entity(EQUIPMENTS_SCHEMA_NAME, {}, {
  idAttribute: `code`,
})

export const equipmentsSelector = createSelectorForEntityKey(EQUIPMENTS_SCHEMA_NAME)
export const equipmentsEntitiesSelector = createEntitiesSelector(EQUIPMENTS_SCHEMA_NAME)

export const getEquipmentsByDispatchingNameQuery = (dispatchingName) => ({ dispatchingName })

const searchEquipmentsByDispatchingName = (dispatchingName = ``) => ({
  type      : `SEARCH_EQUIPMENTS_BY_DISPATCHING_NAME`,
  [CALL_API]: {
    url    : `${REACT_APP_REFERENSE_PASSPORT}/ds/data/object/mainobjectv1DS?page=1&perPage=20`,
    options: {
      method: `POST`,
      schema: equipmentsSchema,
      body  : {
        filter: {
          type    : `AND`,
          operands: [
            {
              type      : `CONTAINS`,
              ignoreCase: true,
              left      : {
                type     : `COMMON_ATTRIBUTE`,
                attribute: `info`,
              },
              right: {
                type    : `constant`,
                dataType: {
                  type: `TEXT`,
                },
                value: dispatchingName,
              },
            },
          ],
        },
        sorting: [
          {
            property : `info`,
            direction: `ASC`,
          },
        ],
      },
    },
    entity: EQUIPMENTS_SCHEMA_NAME,
    key   : stringify(getEquipmentsByDispatchingNameQuery(dispatchingName)),
  },
})

const getEquipmentByCode = (code) => ({
  type      : `GET_EQUIPMENT_BY_CODE`,
  [CALL_API]: {
    url    : `${REACT_APP_REFERENSE_PASSPORT}/objects/data/rowByKey/object/v1/${code}`,
    options: {
      method: `GET`,
      schema: equipmentsSchema,
    },
    entity: EQUIPMENTS_SCHEMA_NAME,
    key   : code,
  },
})

export const equipmentsApiActions = {
  searchEquipmentsByDispatchingName,
  getEquipmentByCode,
}
